import {Renderer2, Component, Inject, Output, EventEmitter, ViewChild, ElementRef, HostListener} from '@angular/core';
import {DOCUMENT, NgClass, NgIf, Location} from "@angular/common";
import {UserService} from "../../../services/user.service";
import {AuthService} from "../../../services/auth.service";
import {SubscriptionService} from "../../../services/subscription.service";
import {BillingService} from "../../../services/billing.service";
import {selectLogoutFailure, selectLogoutSuccess} from "../../../state/auth/auth.selectors";
import {Subscription} from "rxjs";
import {PopupService} from "../../../services/popup.service";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import { logout } from "../../../state/auth/auth.actions";
import * as UiActions from "../../../state/ui/ui.actions";
import {animate, style, transition, trigger} from "@angular/animations";
import {toggleReportSidebarTab} from "../../../state/ui/ui.actions";

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.scss'],
  animations: [
    trigger('backdropAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-linear', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms ease-linear', style({ opacity: 0 }))
      ])
    ]),
    trigger('menuAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in-out', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)' }),
        animate('300ms ease-in-out', style({ transform: 'translateX(-100%)' }))
      ])
    ]),
    trigger('closeButtonAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms ease-in-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ReportHeaderComponent {

  @Output() dataEmitter: EventEmitter<any> = new EventEmitter();
  @Output() dataEmitter2 = new EventEmitter<boolean>(); // for aside state
  @Output() asideStateChange = new EventEmitter<{isOpen: boolean, isClosing: boolean}>();

  subscription: any;
  user: any;
  isLoading: boolean = false;
  range: string = '10';
  linkedin = '';

  private logoutSubscription: Subscription = new Subscription();
  isLoggedIn: boolean = true;

  sidebarTabs = [
    { id: 1, name: 'Tags', current: false },
    { id: 2, name: 'Assistant', current: false },
    { id: 3, name: 'Edit', current: false },
    { id: 4, name: 'Notes', current: false },
    { id: 5, name: 'Emails', current: false },
    { id: 6, name: 'CRM', current: false },
  ]

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT)
    private document: Document,
    private userService: UserService,
    private authService: AuthService,
    private subscriptionService: SubscriptionService,
    private billingService: BillingService,
    private popupService: PopupService,
    private store: Store,
    private router: Router,
    private location: Location

) {
    this.mediaQuery = window.matchMedia('(max-width: 768px)');

    this.authService.authUser().subscribe(user => {
      this.user = user;
    });

    this.subscriptionService.subscriptionData().subscribe(subscription => {
      this.subscription = subscription;
    });

  }

  mediaQuery: MediaQueryList;
  isMenuOpen = false;
  isUserOpen = false;
  isDarkMode = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  isMobile(): boolean {
    return this.mediaQuery.matches;
  }

  /*
  toggleUser() {
    this.isUserOpen = !this.isUserOpen;
  }
  */

  /*
  toggleDarkMode(isDark: boolean) {
    const hostElement = this.document.body;
    if (isDark) {
      this.renderer.addClass(hostElement, 'dark');
      this.isDarkMode = true
    } else {
      this.renderer.removeClass(hostElement, 'dark');
      this.isDarkMode = false
    }
  }
  */

  // In the component where the aside state is managed
  changeSidebarTab(tabIndex: number): void {
    // Check if the tab is currently active
    const isCurrentlyActive = this.sidebarTabs[tabIndex]?.current;

    // Dispatch the same action as sidebar
    this.store.dispatch(UiActions.toggleReportSidebarTab({
      tabIndex,
      isClosing: isCurrentlyActive || false
    }));

    // Close the mobile menu
    this.isMenuOpen = false;
  }

  /*
  changeSidebarTab(tabIndex: number) {
    this.sidebarTabs.forEach((tab) => {
      tab.current = false
    })

    this.sidebarTabs[tabIndex].current = true

    this.dataEmitter.emit(this.sidebarTabs);

    this.isMenuOpen = false
  }
  */

  /*
  signOut(){
    console.log('[dashboard-header.component] logout')

    this.isLoggedIn = false;

    this.store.dispatch(logout());

    this.logoutSubscription.add(
      this.store.select(selectLogoutSuccess).subscribe(success => {
        if (success) {
          // console.log('Logout success');
          // handle logout success, e.g., navigate to login page

          localStorage.clear(); // Clear local storage
          this.router.navigate(['/login']); // Redirect to the login page

          this.popupService.notify('You have been successfully logout!', 'Logout successfully', 'success');

        }
      })
    );

    this.logoutSubscription.add(
      this.store.select(selectLogoutFailure).subscribe(error => {
        if (error) {
          // console.log('Logout failure', error);
          // handle logout failure, e.g., show error message
        }
      })
    );

  }
  */

  @ViewChild('inputElement') inputElement: ElementRef;

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      this.inputElement.nativeElement.focus();
      event.preventDefault();
    }
  }

  /*
  openBillingPortal() {
    this.billingService.openBillingPortal();
  }
  */

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/human.svg'; // Fallback image when error occurs
  }

  goBack(): void {
    this.location.back();
  }

}
